import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import Submenu from '../common/Submenu';
import cn from 'classnames'
import { getTransactions, sendOrder } from './actions';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import Spiner from '../helpers/Spiner/Spiner';
import WrappedIntlComponent from '../common/intl/WrappedIntlComponent';

class TransactionPage extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  state = {
    transactions: [],
    loaded: false
  }

  async componentDidMount(){
    this.setState({
      transactions: await getTransactions(),
      loaded: true,
    })
  }
  
  render() {
    const {transactions, loaded} = this.state;
    const {formatMessage} = this.props;

    const columns = [
      {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        render: text => '$'+text +' USD',
      },
      {
        title: 'Months',
        dataIndex: 'months',
        key: 'months',
      },
      {
        title: 'Discount',
        dataIndex: 'procent',
        key: 'procent',
        render: procent => procent +'%',
      },
      {
        title: 'Date',
        dataIndex: 'created_at',
        key: 'created_at',
        render: date => moment.unix(date).format('LLL'),
      },
      {
        title: '',
        key: 'action',
        render: (t, item) => {

          const data = JSON.parse(item.data);

          return <div className="profile-form"><button className="btn btn-primary btn-sm" type="button" onClick={() => sendOrder(
            {
              id: item.id,
              subscription: data && data.plan ? data.plan.title : ''
            }, formatMessage)}>{formatMessage('btnSendOrder')}</button></div>;
        },
      },
    ];

    return (
      <Wrapper renderButtonNav = {false}>
        <div className="container content flex-column container-support-wrapper">
            <Submenu />
            <div className={cn([
                "support-wrapper",
                "support-wrapper--flex-full-x-y",
                "flex-1",
                //"support-wrapper--indend-bottom",
                "support-wrapper--height",
            ])}>
              <div style={{width: '100%'}}>
                {!loaded && <Spiner/>}
                {loaded && <Table columns={columns} bordered pagination={false}  dataSource={transactions} />}
              </div>
            </div>
        </div>
      </Wrapper>
    );
  }
}

export default WrappedIntlComponent(TransactionPage);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Transaction/index.jsx